import z from 'zod'

export const notificationAboutCourseSchema = z.object({
  email: z.string().email('Podaj poprawny adres email')
})
export type NotificationAboutCourseSchema = z.infer<typeof notificationAboutCourseSchema>
